import { MARKETING_SECTION_TITLE } from '@/components/marketing/marketing-typography'
import { MarketingEyebrow } from '@/components/marketing/marketing-eyebrow'
import { cn } from '@/lib/utils'

type AuthMarketingIntroProps = {
  eyebrow?: string
  tagline?: string
  className?: string
}

/** Left-column copy hierarchy — mirrors landing hero eyebrow + headline scale. */
export function AuthMarketingIntro({ eyebrow, tagline, className }: AuthMarketingIntroProps) {
  if (!eyebrow && !tagline) return null

  return (
    <div className={cn('max-w-xl', className)}>
      {eyebrow ? (
        <MarketingEyebrow className="mb-4 mt-6 max-lg:mx-auto max-lg:text-center lg:mt-8">
          {eyebrow}
        </MarketingEyebrow>
      ) : null}
      {tagline ? (
        <p className={cn(MARKETING_SECTION_TITLE, 'font-bold max-lg:mx-auto max-lg:text-center')}>
          {tagline}
        </p>
      ) : null}
    </div>
  )
}
